import Vue from "vue";
import Router from "vue-router";
import * as routerConst from "@/common/router.const";
import { clearLoginInfo } from "@/utils";

Vue.use(Router);
let router = new Router({
  routes: [
    {
      path: "/",
      name: routerConst.INDEX,
      redirect: "/home",
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/login",
      name: routerConst.LOGIN,
      component: () => import("@/views/Login.vue"),
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/home",
      name: routerConst.HOME,
      component: () => import("@/views/Home.vue"),
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: "/home/version",
          name: routerConst.VERSION_CONTROL_INDEX,
          component: () => import("@/views/version/VersionIndex.vue"),
          meta: {
            requireAuth: true
          }
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  let token = Vue.prototype.$u.store.state.user.vuex_token;
  if ((token && /\S/.test(token)) || !to.meta.requireAuth) {
    next();
  } else {
    clearLoginInfo();
    next({ name: routerConst.LOGIN });
  }
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default router;
